import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

const ReconcileConfirmationDialog = ({
  isDeleteButton,
  setOpenDialog,
  openDialog,
  handleDeleteSelected,
  associateOrderHandler,
  linkOrderLoading,
  deleteOrderLoading,
}) => {
  return (
    <Dialog
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      aria-labelledby='confirm-dialog-title'
    >
      <DialogTitle id='confirm-dialog-title'>
        {isDeleteButton ? 'Delete Order Confirmation' : 'Confirm Order Association'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {isDeleteButton
            ? 'Are you sure you want to delete selected item?'
            : 'Are you sure you want to link the selected items?'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenDialog(false)} color='inherit'>
          Cancel
        </Button>
        {isDeleteButton ? (
          <LoadingButton
            onClick={() => handleDeleteSelected()}
            loading={deleteOrderLoading}
            variant='contained'
            color='primary'
          >
            Delete
          </LoadingButton>
        ) : (
          <LoadingButton
            onClick={() => associateOrderHandler()}
            loading={linkOrderLoading}
            variant='contained'
            color='primary'
          >
            Link
          </LoadingButton>
        )}
      </DialogActions>
    </Dialog>
  );
};
ReconcileConfirmationDialog.propTypes = {
  isDeleteButton: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.bool.isRequired,
  handleDeleteSelected: PropTypes.func.isRequired,
  associateOrderHandler: PropTypes.func.isRequired,
  linkOrderLoading: PropTypes.bool.isRequired,
  deleteOrderLoading: PropTypes.bool.isRequired,
};

export default ReconcileConfirmationDialog;
